import { Howl, Howler } from 'howler';

export default class SoundEffects {

  constructor() {
    this.soundsData = {
      "intro" : {"file":"music_fx_intro3.mp3","loop":true,"vol":.5},
      "splash" : {"file":"splash.mp3","loop":false,"vol":.25},
      "water" : {"file":"water6.mp3","loop":false,"vol":.25},
      "birds" : {"file":"birds.mp3","loop":true,"vol":.5},
      "kalimba" : {"file":"kalimba_short_tone.mp3","loop":false,"vol":.25},
      "percussion" : {"file":"percussion_short_tone.mp3","loop":false,"vol":.5},
      "bass" : {"file":"bass_short_tone.mp3","loop":false,"vol":.5},
      "calls" : {"file": "calls2.mp3","loop":false,"vol":.05},
      "ding" : {"file": "ding.mp3","loop":false,"vol":.25},
      "win" : {"file": "brass_win.mp3","loop":false,"vol":.5},
      "flamingos_group":{"file": "flamingos_group.mp3","loop":false,"vol":1},
      "tone-0":{"file": "tones/Cymatics - Bongo 1.mp3","loop":false,"vol":.5},
      "tone-1":{"file": "tones/Cymatics - Cowbell 3.mp3","loop":false,"vol":.5},
      "tone-2":{"file": "tones/Cymatics - Djembe Large 2.mp3","loop":false,"vol":.5},
      "tone-3":{"file": "tones/Cymatics - Double Caxixi 1.mp3","loop":false,"vol":.5},
      "tone-4":{"file": "tones/Cymatics - Doumbek 5.mp3","loop":false,"vol":.5},
      "tone-5":{"file": "tones/Cymatics - Hand Chimes 1.mp3","loop":false,"vol":.5},
      "tone-6":{"file": "tones/Cymatics - Kaeba Shaker 1.mp3","loop":false,"vol":.5},
      "tone-7":{"file": "tones/Cymatics - Mini Drum 3.mp3","loop":false,"vol":.5},
      "tone-8":{"file": "tones/Cymatics - Snap Wet.mp3","loop":false,"vol":.5},
      "tone-9":{"file": "tones/Cymatics - Tambourine 2.mp3","loop":false,"vol":.5},

      "c-tone-0":{"file": "tones/Kalimba43.mp3","loop":false,"vol":.5},
      "c-tone-1":{"file": "tones/Kalimba44.mp3","loop":false,"vol":.5},
      "c-tone-2":{"file": "tones/Kalimba45.mp3","loop":false,"vol":.5},
      "c-tone-3":{"file": "tones/Kalimba46.mp3","loop":false,"vol":.5},
      "c-tone-4":{"file": "tones/Kalimba47.mp3","loop":false,"vol":.5},
      "c-tone-5":{"file": "tones/Kalimba48.mp3","loop":false,"vol":.5},
      "c-tone-6":{"file": "tones/Kalimba49.mp3","loop":false,"vol":.5},
      "c-tone-7":{"file": "tones/Kalimba50.mp3","loop":false,"vol":.5},
      "c-tone-8":{"file": "tones/Kalimba51.mp3","loop":false,"vol":.5},
      "c-tone-9":{"file": "tones/Kalimba52.mp3","loop":false,"vol":.5},
      "c-tone-10":{"file": "tones/Kalimba53.mp3","loop":false,"vol":.5}

    }



  }

  init(){

    this.clips = {};
    for(var sound in this.soundsData){
      this.clips[sound] = new Howl({
        src: ['./sounds/'+this.soundsData[sound]["file"]],
        autoplay: false,
        loop: this.soundsData[sound]["loop"],
        volume : this.soundsData[sound]["vol"]
      });
      // this.clips[sound] = new Audio('./sounds/'+this.soundsData[sound]["file"]);
      // this.clips[sound].loop = this.soundsData[sound]["loop"];
      this.clips[sound].baseVolume = this.soundsData[sound]["vol"];

    }


  }

  mute(){
    // for(var clip in this.clips){
    //   this.clips[clip].pause();
    //   //this.clips[clip].volume = 0;
    // }
    this.muted = true;
    Howler.volume(0);
  }

  unMute(){
    // for(var clip in this.clips){
    //   //console.log("unmute clip",clip,this.soundsData[clip].loop,this.soundsData[clip].didPlay)
    //   //this.clips[clip].volume = this.clips[clip].baseVolume;
    //   if(this.soundsData[clip].loop == true && this.soundsData[clip].didPlay){
    //     this.clips[clip].play();
    //     //console.log("unmute clip",clip)
    //   }
    // }
    this.muted = false;
    Howler.volume(1);

  }

  playClip(name, vol = 1){
    if(this.muted)
      return;

    if(this.clips.hasOwnProperty(name)){
      // if(this.muted){
      //   this.clips[name].volume = 0;
      // }else{
      //   this.clips[name].volume = this.clips[name].baseVolume;
      // }
      if(!this.muted && (!this.clips[name].playing() || (name.includes('tone')  || name.includes('kalimba') || name.includes('bass') )) ){
        this.clips[name].play();
        this.soundsData[name].didPlay = true;
      }

    }
  }

  pauseClip(name){
    if(this.clips.hasOwnProperty(name)){
      this.clips[name].pause();
    }
  }

  pauseAll(){
    for(var sound in this.clips){
      this.clips[sound].pause();
    }
  }

  fadeClip(name,fadeouttime=1000){
    console.log("fade clip");
    if(this.clips.hasOwnProperty(name) ){
      if( this.clips[name].playing() ){
        this.clips[name].fade(this.soundsData[name]["vol"], 0, fadeouttime);
      }

    }
  }

  fadeInClip(name,fadetime=1000){
    if(this.clips.hasOwnProperty(name)){

       if(!this.muted && !this.clips[name].playing()){
         this.clips[name].volume(0);
         this.clips[name].play();
         this.soundsData[name].didPlay = true;
         this.clips[name].fade(0,this.soundsData[name]["vol"], fadetime);
       }

    }
  }

};
